import React from "react";
import HeaderSection from "../../components/shared/HeaderSection";

const SoftwareEngineerIntern = () => {
  return (
    <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white min-h-screen">
      {/* Header Section */}
      <HeaderSection
        image="/images/careers/software-engineer.jpg" // Replace with the actual image path
        header="Software Engineer Intern"
        subHeader="Full Stack Development"
      />

      {/* Main Content */}
      <div className="container mx-auto px-6 py-16 max-w-4xl">
        <h2 className="text-3xl font-bold mb-6 text-blue-400">
          Software Engineer Intern – Full Stack Development
        </h2>
        <p className="text-gray-300 mb-4">
          <strong>Location:</strong> Remote
        </p>
        <p className="text-gray-300 mb-4">
          <strong>Job Type:</strong> Internship (Full-Time/Part-Time)
        </p>

        <h3 className="text-2xl font-semibold mb-4 text-white">About the Role:</h3>
        <p className="text-gray-300 mb-6">
          We are seeking a passionate Software Engineer Intern to join our development team. This internship will provide hands-on experience in full-stack web application development using React, Spring Boot, MySQL, MongoDB, and Git. You will work alongside experienced developers to design, develop, and optimize scalable applications.
        </p>

        <h3 className="text-2xl font-semibold mb-4 text-white">Responsibilities:</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-300 mb-6">
          <li>Develop and maintain front-end components using React.js, ensuring responsive and user-friendly UI/UX.</li>
          <li>Implement back-end logic and RESTful APIs using Spring Boot.</li>
          <li>Work with MySQL and MongoDB to manage and optimize database operations.</li>
          <li>Collaborate with the team to integrate front-end and back-end services.</li>
          <li>Use Git for version control and collaborate on projects using Git workflows.</li>
          <li>Participate in code reviews, debugging, and troubleshooting application issues.</li>
          <li>Assist in writing unit and integration tests to ensure software reliability.</li>
          <li>Learn and implement best practices for software development and deployment.</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-4 text-white">Requirements:</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-300 mb-6">
          <li>Currently pursuing or recently completed a degree in Computer Science, Software Engineering, or a related field.</li>
          <li>Basic knowledge and experience with React.js for front-end development.</li>
          <li>Familiarity with Spring Boot for back-end development.</li>
          <li>Understanding of relational (MySQL) and NoSQL (MongoDB) databases.</li>
          <li>Experience using Git for version control and collaboration.</li>
          <li>Strong problem-solving and analytical skills.</li>
          <li>Ability to work both independently and in a team environment.</li>
          <li>Eagerness to learn new technologies and frameworks.</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-4 text-white">Nice to Have:</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-300 mb-6">
          <li>Experience with RESTful API development and microservices.</li>
          <li>Familiarity with containerization (Docker) and cloud platforms.</li>
          <li>Exposure to Agile development methodologies.</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-4 text-white">Benefits:</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-300 mb-6">
          <li>Hands-on experience with modern full-stack development technologies.</li>
          <li>Mentorship from experienced software engineers.</li>
          <li>Opportunity to contribute to real-world projects.</li>
          <li>Potential for a full-time role upon successful internship completion.</li>
        </ul>

        <p className="text-gray-300 mb-6">
          If you are passionate about coding and eager to learn, we'd love to have you on our team! 🚀
        </p>

        <div className="text-center">
          <a
            href="mailto:careers@hithertech.co.uk"
            className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
          >
            Apply Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default SoftwareEngineerIntern;